var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex text-center justify-content-center align-items-center"},[_c('h1',[_vm._v("お疲れ様でした。")]),_c('br')])}]

export { render, staticRenderFns }